module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_mute_video_title":"Mute video","button_mute_audio_title":"Mute audio","button_show_chat_title":"Show chat"},"de":{"button_mute_video_title":"Video stummschalten","button_mute_audio_title":"Audio stummschalten","button_show_chat_title":"Show chat"}}' }


//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Stream.vue
// module id = 148
// module chunks = 1